import { cn } from '@/lib/utils'

/**
 * LOCKED — small-caps section label. Ink is muted-foreground (#6b6272): the
 * round-1 control shipped these at 2.96:1 (--color-faint) and was penalised;
 * do not lighten.
 */
export function SectionLabel({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'text-[0.6875rem] font-semibold uppercase tracking-[0.1em] text-muted-foreground',
        className
      )}
    >
      {children}
    </div>
  )
}
